import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

import { StateService } from '../../../../../services/state.service'
import { DialogService } from '../../../../../services/dialog-service.service'
import { AppService } from '../../../../../services/app.service'
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'groupe'

@Component({
  selector: 'atyl-groupe-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/groupe',
  key: KEY,
})
export class GroupeListComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() perso: boolean=true;
  @Input() mine: boolean=false;
  @Input() allselected: boolean=false;
  
  @Input() instruction: any;
  
  @Input() types:any[]=["ASSMAT"];
  
  @Input() groupeInput:any[]=[];
   
  @Output() onGroupSelected = new EventEmitter<any>();
  @Output() nodeCount:EventEmitter<number> = new EventEmitter<number>();
  
  activeButton:boolean=false;

  forms:any[]=[];
  
  groupes:any[]=[];
  
 

  id:any;
  
  associateButton:boolean=true;

  refreshUser: any=null;
  refreshDossier: any=null;

  user:any;
  
  
 
  
  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private changeDetectorRef: ChangeDetectorRef,
     private tiersService: AppService
  ) { }

  ngOnInit() {
	this.refreshUser=this.stateService.user.subscribe((user) => {
		 		console.log("user dossier user",user);
		 		if (user) {
		                this.user = user
		                console.log("user dossier",this.user)
						if (this.mine)
							this.loadGroupeMine();
						else
							this.loadGroupe();
		            }
		})
		
	 
	 
		 
		 
	 	
     
    
  }
  
  ngOnDestroy() {
	  	
	  	if (this.refreshUser)
	  		this.refreshUser.unsubscribe();
    
  }
  
   loadGroupeMine() {
	   console.log("GroupeComponent load ",this.dossier,this.user);	
	   
	   let _opts:any={
		   
	   }
	  this.groupes=[];
	  this.groupeInput=[];
	   
	   
	   if (this.user!=undefined) {
			this.id=this.user.id;
	   }
	  
	      
	    
	   this.tiersService.getGroupe(this.id,_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("GroupeComponent loaded",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.groupes=res.result;
					this.nodeCount.emit(this.groupes.length);
					this.detectChanges();
					
					if (this.allselected) {
						for(let i=0;i<this.groupes.length;i++) {
							let gp:any=this.groupes[i];
							if (gp.groupe!=undefined && gp.groupe.ID!=undefined)
								this.groupeInput.push(gp.groupe.ID);
						}
						if (this.groupeInput.length>0)
							this.onGroupSelected.emit(this.groupeInput);
						
					}
				}
					
			}
	   );
	   	
   }
   
   loadGroupe() {
   				let _opts:any={
   							personnel: this.perso   
   						}
				this.groupeInput=[];
   				let groupesTT:any[]=[
   					{
   						"label":"Mes Groupes",
   						"groupes":[]
   					},
   					{
   						"label":"Mes Groupes personnels",
   						"groupes":[]
   					}
   				];
   				this.groupes=[];		
   				this.tiersService.getGroupeList(this.types,_opts)
   					.subscribe((res: JSONRpcResponse) => {
   						console.log("GroupeComponent loaded",res);
   						
   						
   						if (res.result 
   							&& res.result!=undefined
   						) {
   							
   							
   							for(let i:number=0;i<res.result.length;i++) {
   								let grp:any=res.result[i];
   								
   								if (grp.propritaire) {
   									groupesTT[1].groupes.push(grp);
   								}
   								else {
   									groupesTT[0].groupes.push(grp);
   								}
   								
   							}
   							
   							let ndc:number=0;
   							if (groupesTT[0].groupes.length>0) {
   								this.groupes.push(groupesTT[0]);
								ndc+=groupesTT[0].groupes.length;
								if (this.allselected) {
									for(let i:number=0;i<groupesTT[0].groupes.length;i++) {
										let gp:any=groupesTT[0].groupes[i];
										if (gp.ID!=undefined)
											this.groupeInput.push(gp.ID);
									}
								}	
							}
   							if (groupesTT[1].groupes.length>0) {
   								this.groupes.push(groupesTT[1]);
								ndc+=groupesTT[1].groupes.length;
								if (this.allselected) {
									for(let i:number=0;i<groupesTT[1].groupes.length;i++) {
										let gp:any=groupesTT[1].groupes[i];
										if (gp.ID!=undefined)
											this.groupeInput.push(gp.ID);
									}
								}
								
   							}	
							this.nodeCount.emit(ndc);
							if (this.groupeInput.length>0)
								this.onGroupSelected.emit(this.groupeInput);					
   							
							this.detectChanges();
   						
   						}
   						
   						
   						
   						
   					})
   	}
   
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
	
	hexToRgbA(hex: string, alpha: any = 255) {
				let color: any
				let newAlpha = Number.parseInt(alpha, 10)

				if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
					color = hex.substring(1).split('')
					if (color.length == 3) {
						color = [color[0], color[0], color[1], color[1], color[2], color[2]]
					}
					color = '0x' + color.join('')
					return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')'
				}
		}
	groupeSelected(event:any) {
			//console.log("userSelected",event);
		if(event && event!=null){
			this.onGroupSelected.emit(this.groupeInput);
		}

	}
  

}
